/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getNotification } from '../fn/notifications/get-notification';
import { GetNotification$Params } from '../fn/notifications/get-notification';
import { listNotifications } from '../fn/notifications/list-notifications';
import { ListNotifications$Params } from '../fn/notifications/list-notifications';
import { NotificationDto } from '../models/notification-dto';
import { NotificationDtoPage } from '../models/notification-dto-page';
import { updateNotification } from '../fn/notifications/update-notification';
import { UpdateNotification$Params } from '../fn/notifications/update-notification';

@Injectable({ providedIn: 'root' })
export class NotificationsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listNotifications()` */
  static readonly ListNotificationsPath = '/v0/notifications';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listNotifications()` instead.
   *
   * This method doesn't expect any request body.
   */
  listNotifications$Response(params?: ListNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationDtoPage>> {
    return listNotifications(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listNotifications$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listNotifications(params?: ListNotifications$Params, context?: HttpContext): Observable<NotificationDtoPage> {
    return this.listNotifications$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationDtoPage>): NotificationDtoPage => r.body)
    );
  }

  /** Path part for operation `getNotification()` */
  static readonly GetNotificationPath = '/v0/notifications/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotification()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotification$Response(params: GetNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationDto>> {
    return getNotification(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotification(params: GetNotification$Params, context?: HttpContext): Observable<NotificationDto> {
    return this.getNotification$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationDto>): NotificationDto => r.body)
    );
  }

  /** Path part for operation `updateNotification()` */
  static readonly UpdateNotificationPath = '/v0/notifications/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateNotification()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateNotification$Response(params: UpdateNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationDto>> {
    return updateNotification(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateNotification$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateNotification(params: UpdateNotification$Params, context?: HttpContext): Observable<NotificationDto> {
    return this.updateNotification$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationDto>): NotificationDto => r.body)
    );
  }

}
